import Backbone from 'backbone';
import { withUiBlock } from '@bingads-webui/uiblocker';
import { CampaignAdgroupSelectorProxy } from './campaign-adgroup-selector-proxy';
import { AdgroupSelectorProxy } from './adgroup-selector-proxy';
import { CampaignSelectorProxy } from './campaign-selector-proxy';

const Scope = {
  Account: 0,
  Campaign: 1,
  AdGroup: 2,
};

const ScopeLiterals = [
  'account',
  'campaign',
  'adgroup',
];

const Level = {
  Campaign: 0,
  AdGroup: 1,
};

const LevelLiterals1 = [
  'campaignLevel',
  'adGroupLevel',
];

const LevelLiterals2 = [
  'campaign',
  'adgroup',
];

function isAccountScope(scope) {
  return scope === Scope.Account || scope === ScopeLiterals[Scope.Account];
}

function isCampaignScope(scope) {
  return scope === Scope.Campaign || scope === ScopeLiterals[Scope.Campaign];
}

function isAdGroupLevel(level) {
  return level === Level.AdGroup || level === LevelLiterals1[Level.AdGroup] || level === LevelLiterals2[Level.AdGroup];
}

function isCampaignLevel(level) {
  return level === Level.Campaign || level === LevelLiterals1[Level.Campaign] || level === LevelLiterals2[Level.Campaign];
}

export function createCampaignAdGroupSelector({
  jsData,
  edmCampaign,
  scope,
  level,
  campaignId,
  i18n,
  getCustomizedCampaignData,
  getCustomizedAdGroupData,
  selectedCampaign,
  selectedAdGroup,
  optionalCampaignFilter,
  optionalAdgroupFilter,
  parentView,
  campaignOfAdgroup,
  optionalCampaignSelect,
  optionalAdGroupSelect,
  optionalAdGroupExpand,
  optionalOnCampaignSelect = null,
}) {
  if (isAdGroupLevel(level) && isAccountScope(scope)) {
    const campaignAdgroupSelectorProxy = new CampaignAdgroupSelectorProxy({
      onCampaignSelect: optionalOnCampaignSelect || (() => {}),
      onAdGroupSelect: (adGroup) => {
        parentView.trigger('adgroupSelected', adGroup);
      },
      jsData,
      edmCampaign,
      withUiBlocker: uiBlockContainer => withUiBlock(uiBlockContainer),
      i18n,
      getCustomizedCampaignData,
      getCustomizedAdGroupData,
      optionalCampaignFilter,
      optionalAdgroupFilter,
      selectedCampaign,
      selectedAdGroup,
      optionalCampaignSelect,
      optionalAdGroupSelect,
      optionalAdGroupExpand,
    });
    return campaignAdgroupSelectorProxy.getCampaignAdgroupSelectorView();
  } else if (isAdGroupLevel(level) && isCampaignScope(scope)) {
    const adgroupSelectorProxy = new AdgroupSelectorProxy({
      campaignId,
      onEventTrigger: (adGroup) => {
        parentView.trigger('adgroupSelected', adGroup);
      },
      jsData,
      edmCampaign,
      withUiBlocker: uiBlockContainer => withUiBlock(uiBlockContainer),
      i18n,
      getCustomizedData: getCustomizedAdGroupData,
      optionalAdgroupFilter,
      selectedItem: selectedAdGroup,
      campaign: campaignOfAdgroup,
      optionalCampaignSelect,
      optionalAdGroupSelect,
      optionalAdGroupExpand,
    });
    return adgroupSelectorProxy.getAdgroupSelectorView();
  } else if (isCampaignLevel(level) && isAccountScope(scope)) {
    const campaignSelectorProxy = new CampaignSelectorProxy({
      onEventTrigger: (campaign) => {
        parentView.trigger('campaignSelected', campaign);
      },
      jsData,
      edmCampaign,
      withUiBlocker: uiBlockContainer => withUiBlock(uiBlockContainer),
      i18n,
      getCustomizedData: getCustomizedCampaignData,
      optionalCampaignFilter,
      selectedItem: selectedCampaign,
      optionalCampaignSelect,
    });
    return campaignSelectorProxy.getCampaignSelectorView();
  }
  return new Backbone.View();
}
